import { render, staticRenderFns } from "./SpecsTable.vue?vue&type=template&id=e7cc0014&scoped=true&"
import script from "./SpecsTable.vue?vue&type=script&lang=js&"
export * from "./SpecsTable.vue?vue&type=script&lang=js&"
import style0 from "./SpecsTable.vue?vue&type=style&index=0&id=e7cc0014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7cc0014",
  null
  
)

export default component.exports